export default "__VITE_ASSET__Db9c1zGE__"